<template>
  <div id="app-series">
    <search-products 
      :myItemComponent = "itemComponent"
      :myKey = "filterKey"
      :myDir = "filterDir"
      @searchRecords = 'searchProducts'
      @detailChange = "changeDetail"
      @keyChange = "changeKey"
      @dirChange = "changeDir" />
    <p class="selected-items">{{msgSelected}}</p>
    <product-list
      :products = 'filteredProducts' :currentItemComponent = "itemComponent"/>
  </div>
</template>

<script>
import _ from 'lodash';
import SearchProducts from './SearchProducts.vue';
import ProductList from './ProductList.vue';

export default {
  name: 'app-series',
  data () {
    return {
      theProducts: [],
      searchTerms: '',
      itemComponent: 'product-item',
      filterKey: 'mpn', // nameRU - сортировка по имени
      filterDir: 'asc'
    }
  }, //data

  components: {
    'search-products': SearchProducts,
    'product-list': ProductList
  }, //components

  created: function() {
    this.theProducts = productItemList;
  }, //created

  methods: {
    searchProducts: function(terms) {
      this.searchTerms = terms;
    }, //searchProducts

    changeDetail: function(value) {
      this.itemComponent = value;
    }, //changeListDetail

    changeKey: function(value) {
      this.filterKey = value;
    }, //changeKey

    changeDir: function(value) {
      this.filterDir = value;
    }, //changeKey
  }, //methods

  computed: {

    msgSelected: function() {
      if (this.theProducts.length == this.filteredProducts.length) {
        return 'Всего ' + this.theProducts.length + ' товаров';
      }
      else { 
        return 'Выбрано ' + this.filteredProducts.length + 
          ' из ' + this.theProducts.length + ' товаров';
      }
      
    }, //msgSelected

    searchedProducts: function() {
      return this.theProducts.filter(function(item) {
        return (
          (item.slug.toLowerCase().match(this.searchTerms.toLowerCase())) ||
          (item.nameRU.toLowerCase().match(this.searchTerms.toLowerCase())) ||
          (item.nameIT.toLowerCase().match(this.searchTerms.toLowerCase())) ||
          (item.nameEN.toLowerCase().match(this.searchTerms.toLowerCase()))
        )
      }.bind(this));
    }, //searchedProducts

    filteredProducts: function() {
      var cmpFunction = function(item) {
        return item[this.filterKey].toLowerCase();
      };
      if ((this.filterKey == 'price') || (this.filterKey == 'width') || 
          (this.filterKey == 'depth') || (this.filterKey == 'height')) {
        cmpFunction = function(item) { 
          return parseFloat(item[this.filterKey]);
        };
      }
      return _.orderBy(this.searchedProducts, cmpFunction.bind(this), this.filterDir);
    } //filteredProducts

  } //computed
}
</script>

<style scoped>
#app-series {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 30px;
  margin-bottom: 60px;
}

.selected-items {
  text-align: center;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/AppSeries.vue